const ErrorMessage = ({ message }: { message: string | undefined }) => {
    return message ? (
        <span role='alert' className='text-xs text-[--tb-primary]'>
            {message}
        </span>
    ) : null
}

export default ErrorMessage
